import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { treatmentServices } from '@/mocks/treatmentServices';

export default function TreatmentAreasSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section id="treatment-areas" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-rose-50 text-rose-500 text-xs font-semibold rounded-full mb-4 uppercase tracking-wider">
            {t('treatment_badge')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-['Outfit']">
            {t('treatment_title')}
            <span className="text-rose-500"> {t('treatment_title_highlight')}</span>
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            {t('treatment_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {treatmentServices.map((treatment) => (
            <button
              key={treatment.id}
              onClick={() => navigate(`/saglik-kurumlari?service=${treatment.id}`)}
              className={`group relative text-left rounded-2xl overflow-hidden border ${treatment.border} bg-gradient-to-br ${treatment.bg} hover:-translate-y-1 transition-all duration-300 cursor-pointer`}
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={treatment.image}
                  alt={t(treatment.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                {t(treatment.tagKey) && (
                  <span className={`absolute top-3 left-3 px-2.5 py-0.5 ${treatment.tagColor} text-white text-[10px] font-bold rounded-full`}>
                    {t(treatment.tagKey)}
                  </span>
                )}
                <div className={`absolute bottom-3 right-3 w-9 h-9 flex items-center justify-center rounded-xl bg-gradient-to-br ${treatment.color} shadow-lg`}>
                  <i className={`${treatment.icon} text-white text-base`}></i>
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-sm font-bold text-gray-900 mb-0.5 font-['Outfit']">{t(treatment.titleKey)}</h3>
                <p className="text-[11px] font-medium text-gray-400 mb-2">{t(treatment.subtitleKey)}</p>
                <p className="text-xs text-gray-500 leading-relaxed line-clamp-2">{t(treatment.descriptionKey)}</p>
                <div className="mt-3 flex items-center text-xs font-semibold text-rose-500 group-hover:translate-x-1 transition-transform">
                  {t('treatment_view_institutions')}
                  <i className="ri-arrow-right-s-line ml-1 text-sm"></i>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/saglik-kurumlari')}
            className="inline-flex items-center gap-2 px-7 py-3 border-2 border-gray-200 text-gray-700 rounded-xl font-semibold text-sm hover:border-rose-300 hover:text-rose-500 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-hospital-line"></i>
            {t('treatment_view_all')}
          </button>
        </div>
      </div>
    </section>
  );
}
